module.exports = __webpack_public_path__ + "static/img/wl1300bb.52e9ea7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/wl1300bb.jpg
// module id = 4K27
// module chunks = 0